// extracted by mini-css-extract-plugin
module.exports = {"share-btn":"index_share-btn_1L3Vv","share-tip":"index_share-tip_2v7J0"};